import { OrderPriceRoundingModeEnum } from '@clubpay/customer-common-module/src/repository/vendor';
import { ceil, floor, round } from 'lodash';

export const kRoundNumber = (
    amount: string | number,
    precision: number,
    rounding: OrderPriceRoundingModeEnum = OrderPriceRoundingModeEnum.Round,
): number => {
    if (typeof amount === 'string') {
        amount = Number(amount);
    }
    switch (rounding) {
        default:
        case OrderPriceRoundingModeEnum.Round:
            return round(amount, precision);
        case OrderPriceRoundingModeEnum.Floor:
            return floor(amount, precision);
        case OrderPriceRoundingModeEnum.Ceil:
            return ceil(amount, precision);
    }
};

export const normalizeValue = (val: string | number, currencyPrecision: number) => {
    const dec = 10 ** (currencyPrecision || 0);
    return Math.round((typeof val === 'string' ? parseFloat(val) : val) * dec) / dec;
};

export const normalizeValueString = (val: string | number, currencyPrecision: number) => {
    return normalizeValue(val, currencyPrecision || 0).toFixed(currencyPrecision || 0);
};
